import { render, staticRenderFns } from "./Overview.vue?vue&type=template&id=a4054b00"
import script from "./Overview.vue?vue&type=script&lang=js"
export * from "./Overview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4054b00')) {
      api.createRecord('a4054b00', component.options)
    } else {
      api.reload('a4054b00', component.options)
    }
    module.hot.accept("./Overview.vue?vue&type=template&id=a4054b00", function () {
      api.rerender('a4054b00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/section/Overview.vue"
export default component.exports